// Fetch wrappers for the workspace homepage (B5).
//
// apiHome          — GET /app/api/home (hero + recent + pinned + tags).
// apiPinAdd/Remove — POST/DELETE /app/api/pins (pin-by-search / unpin).
// apiPinReorder    — PUT /app/api/pins/order (pinned-manager reorder).
// apiHealthSummary — GET /app/api/health (B3 endpoint, consumed for counts).

const q = (orgSlug, wsHandle) =>
  '?org=' + encodeURIComponent(orgSlug) +
  '&workspace=' + encodeURIComponent(wsHandle);

export async function apiHome(orgSlug, wsHandle, opts = {}) {
  let url = '/app/api/home' + q(orgSlug, wsHandle);
  if (opts.recent != null) url += '&recent=' + encodeURIComponent(String(opts.recent));
  const r = await fetch(url);
  if (!r.ok) throw new Error('/app/api/home ' + r.status);
  return await r.json();
}

export async function apiPinAdd(orgSlug, wsHandle, filePath) {
  const r = await fetch('/app/api/pins' + q(orgSlug, wsHandle), {
    method: 'POST', headers: { 'Content-Type': 'application/json' },
    body: JSON.stringify({ file_path: filePath }),
  });
  if (!r.ok) throw new Error('/app/api/pins ' + r.status);
  return await r.json();
}

export async function apiPinRemove(orgSlug, wsHandle, filePath) {
  const r = await fetch('/app/api/pins' + q(orgSlug, wsHandle), {
    method: 'DELETE', headers: { 'Content-Type': 'application/json' },
    body: JSON.stringify({ file_path: filePath }),
  });
  if (!r.ok) throw new Error('/app/api/pins ' + r.status);
}

export async function apiPinReorder(orgSlug, wsHandle, orderedPaths) {
  const r = await fetch('/app/api/pins/order' + q(orgSlug, wsHandle), {
    method: 'PUT', headers: { 'Content-Type': 'application/json' },
    body: JSON.stringify({ ordered_paths: orderedPaths }),
  });
  if (!r.ok) throw new Error('/app/api/pins/order ' + r.status);
  return await r.json();
}

// Consumes B3's /app/api/health. The card only needs counts (list lengths +
// truncated). Returns the raw HealthOutput; the caller derives counts.
export async function apiHealthSummary(orgSlug, wsHandle, opts = {}) {
  let url = '/app/api/health' + q(orgSlug, wsHandle);
  url += '&stale_days=' + encodeURIComponent(String(opts.staleDays ?? 90));
  url += '&limit=' + encodeURIComponent(String(opts.limit ?? 200));
  const r = await fetch(url);
  if (!r.ok) throw new Error('/app/api/health ' + r.status);
  return await r.json();
}
